var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHog = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 196,
    viewBox: "0 0 218 196",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3CEC4",
    fillRule: "evenodd",
    d: "M7.647 88.682c-21.876 37.765 9.487 126.342 97.705 102.754 88.218-23.587 34.799-17.723 89.305-29.931 54.507-12.208 2.807-101.95-77.552-147.971C36.745-32.487 29.523 50.917 7.647 88.682z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHog, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hog.83592111.svg";
export { ForwardRef as ReactComponent };